export { AlertModal } from './ui/AlertModal';
export { alertReducer, openAlert, closeAlert } from '@widgets/AlertModal/model/slice/alertSlice';
